<template>
  <!--  -->
  <div
    class="fromGroup relative"
    :class="`${error ? 'has-error' : ''}  ${horizontal ? 'flex' : ''}  ${
      validate ? 'is-valid' : ''
    } `"
  >
    <!--  -->
    <label
      v-if="label"
      :class="`${classLabel} inline-block input-label `"
      :for="name"
    >
      {{ label }}
    </label>
    <!--  -->

    <!--  -->
    <div class="relative">
      <!--  -->
      <select
        :name="name"
        :class="`${classInput} input-control block w-full focus:outline-none`"
        :error="error"
        :id="name"
        :readonly="isReadonly"
        :disabled="disabled"
        :validate="validate"
        :formatter="formatter"
        :size="size"
        :multiple="multiple"
        :value="value"
        @input="$emit('input', $event.target.value)"
        @change="$emit('change', $event.target.value)"
      >
        <!--  -->
        <option class="bg-white" value="" disabled selected>
          {{ placeholder }}
        </option>
        <!--  -->

        <!--  -->
        <template v-if="!$slots.default && options">
          <!--  -->
          <option
            class="bg-white"
            v-for="(item, index) in options"
            :value="item"
            :key="index"
          >
            {{ item }}
          </option>
          <!--  -->
        </template>
        <!--  -->

        <!--  -->
        <slot v-if="$slots.default"></slot>
        <!--  -->
      </select>
      <!--  -->
    </div>
    <!--  -->

    <!--  -->
    <span
      v-if="error"
      class="mt-2"
      :class="
        msgTooltip
          ? ' inline-block bg-danger-500 text-white text-[10px] px-2 py-1 rounded'
          : ' text-danger-500 block text-sm'
      "
    >
      {{ error }}
    </span>
    <!--  -->

    <!--  -->
    <span
      v-if="validate"
      class="mt-2"
      :class="
        msgTooltip
          ? ' inline-block bg-success-500 text-white text-[10px] px-2 py-1 rounded'
          : ' text-success-500 block text-sm'
      "
    >
      {{ validate }}
    </span>
    <!--  -->

    <!--  -->
    <span
      class="block text-secondary-500 font-light leading-4 text-xs mt-2"
      v-if="description"
    >
      {{ description }}
    </span>
    <!--  -->
  </div>
  <!--  -->
</template>

<script>
export default {
  props: {
    value: {
      type: [String, Number],
      default: "",
    },
    placeholder: {
      type: String,
      default: "Select Option",
    },
    label: {
      type: String,
    },
    classLabel: {
      type: String,
      default: " ",
    },
    classInput: {
      type: String,
      default: "min-h-[40px]",
    },
    name: {
      type: String,
    },
    error: {
      type: String,
    },
    isReadonly: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    horizontal: {
      type: Boolean,
      default: false,
    },
    validate: {
      type: String,
    },
    msgTooltip: {
      type: Boolean,
      default: false,
    },
    formatter: {
      type: Function,
      default: (value) => value,
    },
    description: {
      type: String,
    },
    size: {
      type: String,
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    options: {
      type: Array,
      default: () => [
        {
          value: "",
          label: "Select Option",
        },
        {
          value: "",
          label: "Select Option2",
        },
      ],
    },
  },
};
</script>

<style lang="scss" scoped>
select {
  appearance: none;
  background: url("https://api.iconify.design/akar-icons/chevron-down.svg");
  background-repeat: no-repeat;
  background-position: right;
  background-position-x: 96%;
  background-size: 0px;
}

option {
  text-transform: capitalize;
}
</style>
